export default theme => ({
  backButton: {
    marginBottom: 25,
    display: "flex",
    height: "100%",
    alignItems: "center",
  },
  backButton_text: {
    marginLeft: 15,
    display: "inline-block",
  },
  backButton_icon: {
    display: "inline-block",
    verticalAlign: "middle",
  },
  backButton__container: {
    marginTop: "1em",
    cursor: "pointer",
  },
});
